module.exports = __webpack_public_path__ + "static/bromo-tengger-semeru-18be6d1665f0dbbf33a4acfbef60e5a8.png";